<template lang="pug">
  transition(name="fade")
    div.legend.legend--treads(:class="showMapLegend ? 'open' : 'close'")
      e-perfect-scrollbar
        div.head(@click="showMapLegend = !showMapLegend")
          h2.title {{$translate('Обозначения')}}
          //span.toolbar-filter__close
          span.legend__close(v-if="showMapLegend")
          span.legend__open(v-else)

        div.type-group.map-mapping-selector
          div.type.all
            label.checked
              span
              span.marker Отобразить все элементы карты
            label.new-check
              input.new-checkbox(type="checkbox" @change="$emit('showAll', showAll)" v-model="showAll")
              span
          div.type.all-treads
            label.checked
              span
              span.marker Отобразить все потоки
            label.new-check
              input.new-checkbox(type="checkbox" @change="$emit('showAllThreads', showAllThreads)" v-model="showAllThreads")
              span

        div.type-group.obj
          div.type
            label.checked
              span.marker {{$translate('Объекты обращения с отходами')}}
          div.group
            //div.type.obj-obrab
              label.checked
                input.checkbox(type="checkbox")
                span
                span.marker Объекты обработки
            div.type.obj-utiliz
              label.checked
                span.marker {{$translate('Объекты обращения с отходами')}}
                //span.marker Объекты утилизации
            //div.type.obj-obezvr
              label.checked
                input.checkbox(type="checkbox")
                span
                span.marker Объекты обезвреживания
            //div.type.obj-chran
              label.checked
                input.checkbox(type="checkbox")
                span
                span.marker Объекты хранения
            //div.type.obj-zachoron
              label.checked
                input.checkbox(type="checkbox")
                span
                span.marker Объекты захоронения
            div.type.obj-mps
              label.checked
                span.marker {{$translate('МПС (МПП)')}}
            div.type.obj-mmtzoo
              label.checked
                span.marker {{$translate('ММЦОО')}}

        div.type-group.loc
          div.type
            label.checked
              span.marker {{$translate('Населенные пункты')}}
          div.group
            div.type.loc-distrib
              label.checked
                span.marker {{$translate('Отходы распределены')}}
            <!--div.type.loc-notdistrib-->
              <!--label.checked-->
                <!--span.marker {{$translate('Отходы не распределены')}}-->

        div.type-group.lines
          div.type
            label.checked
              input.checkbox(type="checkbox" @change="showAllChange" v-model="showAllLine")
              span
              span.marker {{$translate('Потоки')}}
            label.new-check
              input.new-checkbox(type="checkbox")
              span
          div.group
            div.type.lines-any(v-for='val,key in threadConstants.pointTypes')
              label.checked
                input.checkbox(type="checkbox" @change="showHideLine(key)" v-model="showLines[key]")
                span
                span.marker
                  span(
                  :style="getLineStyle('fact', key)"
                  ).line-color
                  | {{val}}
            //-
              div.type.lines-any
                label.checked
                  input.checkbox(type="checkbox" @change="$emit('showTKOLine', showTKOLine)" v-model="showTKOLine")
                  span
                  span.marker
                    span(
                    :style="getLineStyle('fact', 'tko')"
                    ).line-color
                    | {{$translate('ТКО')}}
              div.type.lines-any
                label.checked
                  input.checkbox(type="checkbox" @change="$emit('showOtherLine', showOtherLine)" v-model="showOtherLine")
                  span
                  span.marker
                    span(
                      :style="getLineStyle('fact', 'other')"
                    ).line-color
                    | {{$translate('Прочие отходы')}}
              div.type.lines-any
                label.checked
                  input.checkbox(type="checkbox" @change="$emit('showMixedLine', showMixedLine)" v-model="showMixedLine")
                  span
                  span.marker
                    span(
                      :style="getLineStyle('fact', 'mixed')"
                    ).line-color
                    | {{$translate('Смешанный поток')}}
        div.type-group.load.loading
          div.type
            label.checked
              span.marker {{$translate('Нагрузка объекта')}}
          div.group
            div.type.load-low
              label.checked
                span.marker {{$translate('Минимальная нагрузка')}}
            div.type.load-mid
              label.checked
                span.marker {{$translate('Средняя нагрузка')}}
            div.type.load-high
              label.checked
                span.marker {{$translate('Максимальная нагрузка')}}

        div.type-group.load
          div.type
            label.checked
              span.marker {{$translate('Статус')}}
            label.new-check
              input.new-checkbox(type="checkbox")
              span
          div.group
            div.type.status-active
              label.checked
                input.checkbox(type="checkbox" @change="$emit('showStatusActive', showStatusActive)" v-model="showStatusActive")
                span
                span.marker {{$translate('Действующий')}}
            div.type.status-planned
              label.checked
                input.checkbox(type="checkbox" @change="$emit('showStatusPlan', showStatusPlan)" v-model="showStatusPlan")
                span
                span.marker {{$translate('Планируемый')}}
</template>

<script>
  import {TREADS_POLY_STYLE, TREADS_POLY_SUBCOLOR} from "../../../config/map";

  export default {
    name: 'map-legend',
    data: () => ({
        showAll: false,
        showAllThreads: false,
        showLines: {isEmpty: true},
        showAllLine: true,
        showAllStatus: true,
        showStatusActive: true,
        showStatusPlan: true,
        /*showTKOLine: true,
        showOtherLine: true,
        showMixedLine: true,*/
        showModelTariffs: false,
    }),
    props: {
      showRemoved: {
        type: Boolean,
        default: false
      }
    },
    created(){
      this.$store.commit('threadConstantLoad');
    },
    computed: {
      threadConstants() {
        let arr = this.$store.state.threadConstant;
        if (typeof arr.pointTypesColors == 'undefined')
          return {};
        if (this.showLines.isEmpty) {
          this.showLines = {};
          let keys = Object.keys(arr.pointTypesColors);
          for(let k in keys) {
            this.$set(this.showLines, keys[k], true);
          }
          this.$emit('initThreadTypes', keys);
        }
        return arr;
      },
      showMapLegend: {
        get () {
          return this.$store.state.showMapLegend
        },
        set (value) {
          this.$store.commit('mapLegend', value)
        }
      }
    },
    methods: {
      showHideLine(key) {
        let vals = Object.values(this.showLines).filter(a => a);
        let allKeys = Object.keys(this.threadConstants.pointTypesColors);
        this.showAllLine = vals.length == allKeys.length;
        this.$emit('showHideLine', [key])
      },
      showAllChange(e){
        let arr = Object.keys(this.threadConstants.pointTypesColors) ;
        this.$emit('showHideLine', null);
        if (this.showAllLine) {
          this.$emit('showHideLine', arr);
          for(let k in arr) {
            this.$set(this.showLines, arr[k], true);
          }
        }
        else {
          this.showLines = {};
        }
        /*
        this.showTKOLine = this.showAllLine ;
        this.showOtherLine  = this.showAllLine;
        this.showMixedLine  = this.showAllLine;
        this.$emit('showTKOLine', this.showAllLine);
        this.$emit('showOtherLine', this.showAllLine);
        this.$emit('showMixedLine', this.showAllLine);*/
      },
      getLineStyle (type, subtype) {
        const style = {...TREADS_POLY_STYLE[type]}

        /*if (subtype && TREADS_POLY_SUBCOLOR[subtype]) {
          style.color = TREADS_POLY_SUBCOLOR[subtype]
        }*/
        // забиваем цвета из настроек
        if (this.threadConstants?.pointTypesColors &&  subtype in this.threadConstants?.pointTypesColors ) {
          style.color = '#' + this.threadConstants.pointTypesColors[subtype];
        }

        if (style.dashArray) {
          return `background:repeating-linear-gradient(90deg, ${style.color}, ${style.color} 10px, transparent 10px, transparent 20px);`
        }

        return `background:${style.color};`
      }
    }
  }
</script>

<style>
  .legend.legend--treads .type-group .type.all{
    border-bottom: none;
    margin-left: -4px;
  }
  .legend.legend--treads .type-group .type.all-treads{
    border-top: none;
    margin-left: -4px;
  }
  /* снять ховер с элементов нагрузки */
  .legend.legend--treads .type-group.loading .group .type:hover {background: inherit;}
</style>
